<template>
    <TheNav></TheNav>
    <div class="p-5">
        <h3>
            中号 md
        </h3>
        <ButtonThe3DButton color="gray" size="sm"> 
            灰色
        </ButtonThe3DButton>
        <ButtonThe3DButton color="gray" size="md"> 
            灰色
        </ButtonThe3DButton>
        <br/>
        <br/>
        <ButtonThe3DButton color="red" size="md">
            红色
        </ButtonThe3DButton>
        <ButtonThe3DButton color="red" size="md" >
            不禁用
        </ButtonThe3DButton>
        <ButtonThe3DButton color="red" size="md" :disabled="true">
            禁用效果
        </ButtonThe3DButton>
        <ButtonThe3DButton color="blue" size="md" :disabled = "true">
            禁用效果
        </ButtonThe3DButton>
        <ButtonThe3DButton  v-click-and-rest>
            防止连点
        </ButtonThe3DButton>
        <br/>
        <!--  -->
        <!--  -->
        <!--  -->
        <h3>
            大号 lg
        </h3>
        <section>
            <ButtonThe3DButton color="blue" size="lg">
                蓝色
            </ButtonThe3DButton>
            <ButtonThe3DButton color="blue" size="lg">
                <template #icon>
                    <IconSvgUse use="icon-online" />
                </template>
                有图标
            </ButtonThe3DButton>
            <ButtonThe3DButton color="blue" size="lg">
                多行文字
                <template #secondRow>
                    等二行
                </template>
            </ButtonThe3DButton>
            <ButtonThe3DButton color="blue" size="lg">
                <template #icon>
                    <IconSvgUse use="icon-online" />
                </template>
                图标+多行文字
                <template #secondRow>
                    等二行
                </template>
            </ButtonThe3DButton>
        </section>
        <!--  -->
        <!--  -->
        <!--  -->
        <h3>
            宽度100%
        </h3>
        <ButtonThe3DButton color="blue" size="md" fullWidth>
            宽度100%
        </ButtonThe3DButton>
        <ButtonThe3DButton color="blue" size="md" fullWidth>
            宽度100%
        </ButtonThe3DButton>
        <h3>
            灰色按钮
        </h3>
        <section class="flex flex-row items-start">
            <ButtonGrayButton :fullWidth="false" :blue="false">
                灰色按钮
            </ButtonGrayButton>
            &emsp;
            <ButtonGrayButton :fullWidth="false" blue>
                蓝色状态
            </ButtonGrayButton>
            &emsp;
            <ButtonGrayButton :fullWidth="false" :hide="['right']">
                Min
            </ButtonGrayButton>
            <ButtonGrayButton :fullWidth="false" :hide="['left']" bald>
                Max
            </ButtonGrayButton>
            &emsp;
            <ButtonGrayButton :fullWidth="false" :hide="['right']">
                Min
            </ButtonGrayButton>
            <ButtonGrayButton :fullWidth="false" :hide="['left', 'right']" bald>
                Max
            </ButtonGrayButton>
            <ButtonGrayButton :fullWidth="false" :hide="['left']">
                Max
            </ButtonGrayButton>
            
        </section>
        <!--  -->
        <section class="pt-6 flex flex-row items-start">
            <div class="flex flex-col">
                <ButtonGrayButton :fullWidth="false" :hide="['bottom']">
                    <IconSvgUse use="icon-arrow-up" width="12" height="12"/> 
                </ButtonGrayButton>
                <ButtonGrayButton :fullWidth="false" :hide="['top']" bald>
                    <IconSvgUse use="icon-arrow-down" width="12" height="12"/> 
                </ButtonGrayButton>
            </div>
            &emsp;
            <div class="flex flex-col">
                <ButtonGrayButton :fullWidth="false" :hide="['bottom']">
                    1/2
                </ButtonGrayButton>
                <ButtonGrayButton :fullWidth="false" :hide="['top']" bald>
                    x2
                </ButtonGrayButton>
            </div>
            &emsp;
            <div class="grid grid-cols-2 gap-0">
                <ButtonGrayButton :fullWidth="false" :hide="['bottom', 'right']" :bald="['right', 'bottom']">
                    A1
                </ButtonGrayButton>
                <ButtonGrayButton :fullWidth="false" :hide="['left', 'bottom']" :bald="['bottom']">
                    A2
                </ButtonGrayButton>
                <ButtonGrayButton :fullWidth="false" :hide="['right', 'top']"  :bald="['right']">
                    A3
                </ButtonGrayButton>
                <ButtonGrayButton :fullWidth="false" :hide="['left', 'top']" >
                    A4
                </ButtonGrayButton>
            </div>
        </section>

        <h3>
            其它按钮
        </h3>
        <section class="flex flex-row items-start">
            <ButtonAddFavorite>
                灰色按钮
            </ButtonAddFavorite>
        </section>
    </div>
</template>

<script setup>
import TheNav from './nav.vue';

</script>

<style scoped>
h3{
    padding: 2em 0 0;
}
</style>





